import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://www.linksciences.com/',
  timeout: 80000
});

// Add a request interceptor
instance.interceptors.request.use((config) => config, (error) => Promise.reject(error));

// Add a response interceptor
instance.interceptors.response.use((response) => response.data, (error) => {
  console.log('Error in axios response: ', error.message);
  return new Promise(() => { });
});

const instance2 = axios.create({
  baseURL: 'https://app.linkmedicine.com/',
  timeout: 80000
});

// Add a request interceptor
instance2.interceptors.request.use((config) => config, (error) => Promise.reject(error));

// Add a response interceptor
instance2.interceptors.response.use((response) => response.data, (error) => {
  console.log('Error in axios response: ', error.message);
  return new Promise(() => { });
});

const instance3 = axios.create({
  baseURL: 'https://api.radar.io/v1/geocode/',
  timeout: 80000
});

// Add a request interceptor
instance3.interceptors.request.use((config) => config, (error) => Promise.reject(error));

// Add a response interceptor
instance3.interceptors.response.use((response) => response.data, (error) => {
  console.log('Error in axios response: ', error.message);
  return new Promise(() => { });
});



export default [instance, instance2, instance3];



// WEBPACK FOOTER //
// ./src/api/ajax.js